// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-icon{
    width:85%;
    height: 50%;
    display: inline;
    margin-right: 5px;
    border-radius: .5rem;
    margin-bottom: .5rem;
}

.headertext {
    margin-left: 10px;
}

.list-container{
    margin-left: 0px;
}

.textareaUpdate{
    min-height: 500px;
}

.input-icon:focus{
    border-width: 2px;
}

.container{
    margin-left: 0px;
}

.button-disabled{
    background: #d4d3d6;
    text-decoration: line-through;
}

.course-grid-top{
    grid-column:1/4;
    height:30px;
}

.notice{
    color: red;
    font-size: 0.75rem;
    margin-bottom: 5px;
}

.icon{
    position: absolute;
    display: inline-block;
    margin-top: 3px;
}

.button-icon {
    /* background: #7c689b; */
    color: #fff;
    font-size: 1rem;
    /* padding: .75rem 1.5rem; */
    border: 0;
    margin-top: 3px;
    /* display: inline-block; */
    width: 40px;
    text-align: center;
    border-radius: .5rem;
    font-weight: bold;
    transition: background 0.2s;
}
.button-icon-add{
    margin-left: 40%;
}
.button-icon:hover {
    cursor: pointer;
}

.material-item{
    display:block;
}`, "",{"version":3,"sources":["webpack://./src/custom.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,SAAS;IACT,eAAe;IACf,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".input-icon{\n    width:85%;\n    height: 50%;\n    display: inline;\n    margin-right: 5px;\n    border-radius: .5rem;\n    margin-bottom: .5rem;\n}\n\n.headertext {\n    margin-left: 10px;\n}\n\n.list-container{\n    margin-left: 0px;\n}\n\n.textareaUpdate{\n    min-height: 500px;\n}\n\n.input-icon:focus{\n    border-width: 2px;\n}\n\n.container{\n    margin-left: 0px;\n}\n\n.button-disabled{\n    background: #d4d3d6;\n    text-decoration: line-through;\n}\n\n.course-grid-top{\n    grid-column:1/4;\n    height:30px;\n}\n\n.notice{\n    color: red;\n    font-size: 0.75rem;\n    margin-bottom: 5px;\n}\n\n.icon{\n    position: absolute;\n    display: inline-block;\n    margin-top: 3px;\n}\n\n.button-icon {\n    /* background: #7c689b; */\n    color: #fff;\n    font-size: 1rem;\n    /* padding: .75rem 1.5rem; */\n    border: 0;\n    margin-top: 3px;\n    /* display: inline-block; */\n    width: 40px;\n    text-align: center;\n    border-radius: .5rem;\n    font-weight: bold;\n    transition: background 0.2s;\n}\n.button-icon-add{\n    margin-left: 40%;\n}\n.button-icon:hover {\n    cursor: pointer;\n}\n\n.material-item{\n    display:block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
